import script from "./CustomCollectionCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCollectionCell.vue?vue&type=script&setup=true&lang=js"

import "./CustomCollectionCell.vue?vue&type=style&index=0&id=f56c0180&lang=scss&scoped=true"
script.__scopeId = "data-v-f56c0180"

export default script